import Marquee from "react-fast-marquee";

const ITEMS = [
  "Billard",
  "Steel Darts",
  "Kicker",
  "Drinks & Snacks",
  "Feierabend",
  "Good Times",
  "Auszeit",
  "Freunde treffen",
];

export default function MarqueeStrip() {
  return (
    <div data-testid="editorial-marquee" className="overflow-hidden border-y border-[#241a15] bg-[#120d0b] py-6">
      <Marquee speed={28} gradient={false}>
        {ITEMS.map((item) => (
          <span
            key={item}
            className="mx-8 flex items-center gap-8 font-display text-2xl italic tracking-wide text-[#c9bda9]/30 md:text-3xl"
          >
            {item}
            <span className="text-sm not-italic text-[#c9a24a]/50">◆</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
